import React, { useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './Header.css';

const LANGS = [
  { code: 'pt', label: 'PT' },
  { code: 'en', label: 'EN' },
  { code: 'es', label: 'ES' },
];

const Header = () => {
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isLangDropdownOpen, setIsLangDropdownOpen] = useState(false);
  const { t, i18n } = useTranslation();

  const isKitLuminaPage = location.pathname === '/kit-lumina';

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    setIsLangDropdownOpen(false);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
    setIsLangDropdownOpen(false);
  };

  const setLang = (lng) => {
    i18n.changeLanguage(lng);
    setIsLangDropdownOpen(false);
  };

  const toggleLangDropdown = () => {
    setIsLangDropdownOpen(!isLangDropdownOpen);
  };

  const getCurrentLangLabel = () => {
    return LANGS.find(lng => i18n.language.startsWith(lng.code))?.label || 'PT';
  };

  return (
    <header className="header">
      <div className="container">
        <div className="header-content">
          <div className="logo">
            <Link to="/" onClick={closeMenu}>
              <picture>
                <source type="image/webp" srcSet="/images/lumina_logo.webp" />
                <img src="/images/lumina_logo.png" alt="Lumina Logo" />
              </picture>
            </Link>
          </div>

          {/* Mobile Language Selector */}
          <div className="mobile-language-wrapper">
            <button 
              className="mobile-language-toggle" 
              onClick={toggleLangDropdown}
              aria-label="Toggle language menu"
            >
              {getCurrentLangLabel()}
            </button>
            {isLangDropdownOpen && (
              <div className="mobile-language-dropdown">
                {LANGS.filter(lng => !i18n.language.startsWith(lng.code)).map(lng => (
                  <button
                    key={lng.code}
                    onClick={() => setLang(lng.code)}
                    className="mobile-language-option"
                  >
                    {lng.label}
                  </button>
                ))}
              </div>
            )}
          </div>
          
          <button className="menu-toggle" onClick={toggleMenu} aria-label="Toggle menu">
            <span className={`menu-icon ${isMenuOpen ? 'open' : ''}`}>
              <span></span>
              <span></span>
              <span></span>
            </span>
          </button>
          
          <nav className={`nav ${isMenuOpen ? 'open' : ''}`}>
            <NavLink to="/" onClick={closeMenu} className={({ isActive }) => isActive ? 'active' : undefined}>{t('menu.home')}</NavLink>
            <NavLink to="/sobre" onClick={closeMenu} className={({ isActive }) => isActive ? 'active' : undefined}>{t('menu.about')}</NavLink>
            <NavLink to="/kit-lumina" onClick={closeMenu} className={({ isActive }) => isActive ? 'active' : undefined}>{t('menu.kit')}</NavLink>
            <NavLink to="/blog" onClick={closeMenu} className={({ isActive }) => isActive ? 'active' : undefined}>{t('menu.blog')}</NavLink>
            <NavLink to="/contato" onClick={closeMenu} className={({ isActive }) => isActive ? 'active' : undefined}>{t('menu.contact')}</NavLink>
          </nav>
          
          <div className="header-actions">
            <button className="btn btn-primary">{t('menu.login')}</button>
            <div className="language-selector" style={{gap: '3px'}}>
              {LANGS.map(lng => (
                <button
                  type="button"
                  key={lng.code}
                  className={i18n.language.startsWith(lng.code) ? 'lang-btn active' : 'lang-btn'}
                  aria-label={lng.label}
                  onClick={() => setLang(lng.code)}
                  style={{fontWeight: i18n.language.startsWith(lng.code) ? 700 : 400, border: 'none', background: 'none', color: '#333', padding: '1px 7px', cursor: 'pointer'}}
                >{lng.label}</button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;

